import { useTranslation } from 'react-i18next'

import { Text, TextAreaRichEditor } from '@reveni-io/reveni-ui'

import InsertVariables from '@/common/components/InsertVariables/InsertVariables'
import { getEmailVariables } from '@/common/helpers/helpers'
import useAddVariable from '@/common/hooks/useAddVariable/useAddVariable'

import * as Styles from './styles'

const Subject = ({ subject, onChangeSubject, languageSelected, availableVariables, availableSections, disabled }) => {
  const { t } = useTranslation()
  const { editorRef, onAddVariable } = useAddVariable({ onChange: onChangeSubject })

  return (
    <Styles.Container>
      <Text type="titleS">{t('Asunto')}</Text>
      <Styles.InputContainer>
        <TextAreaRichEditor
          fullWidth
          textType="html"
          inputType="text"
          value={subject}
          onChange={onChangeSubject}
          label={t('Asunto del email')}
          key={languageSelected}
          variables={getEmailVariables(availableVariables)}
          editorRef={editorRef}
          disabled={disabled}
        />
        <InsertVariables
          onAddVariable={onAddVariable}
          availableVariables={availableVariables}
          availableSections={availableSections}
          disabled={disabled}
          tooltip={t(
            'Inserta variables en tu texto para añadir contenido dinámico como nombres, números de referencia, valores, etc. en tus correos.'
          )}
        />
      </Styles.InputContainer>
    </Styles.Container>
  )
}

export default Subject
